module.exports = "/_next/static/images/nikhil2-42b2da895be847330d6d969bcd3f97f4.png";